/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, string } from '../schema';
import {
  CreditorReference,
  creditorReferenceSchema,
} from './creditorReference';
import { DebtorReference, debtorReferenceSchema } from './debtorReference';

export interface Reference {
  creditorName: string;
  debtorName: string;
  creditorReference: CreditorReference;
  debtorReference: DebtorReference;
}

export const referenceSchema: Schema<Reference> = object({
  creditorName: ['CreditorName', string()],
  debtorName: ['DebtorName', string()],
  creditorReference: ['CreditorReference', lazy(() => creditorReferenceSchema)],
  debtorReference: ['DebtorReference', lazy(() => debtorReferenceSchema)],
});
